import dayjs, { Dayjs } from 'dayjs';
import { Box, Button, DialogActions, Grid, Paper, Tab, Typography } from '@mui/material';
import { LocalizationProvider, StaticDateRangePicker } from '@mui/x-date-pickers-pro';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { getPropertiesBySearchForm, website } from '@/utils/helpers';
import { makeStyles } from 'tss-react/mui';
import { AppContext } from '@/utils/appContext';
import { useTranslation } from 'react-i18next';
import { DateRange, TabContext, TabList, TabPanel } from '@mui/lab';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useResponsive } from '@/hooks/use-responsive';
import { IOpenings } from '@/interfaces/huWebsite';
import axios from 'axios';

export const ModalDatePicker = (props: any) => {
  const { classes } = useStyles();

  const appContext = useContext(AppContext);

  const { t } = useTranslation();

  const { container, handleCloseModalDatePicker } = props.params;

  const [calendarPrice, setCalendarPrice] = useState({});

  /*useEffect(() => {
    const form = appContext.searchForms[appContext.orderIndex];
    axios
      .get(
        `https://hc.azure-api.net/HuSearchForm/calendar-price?pos=HU&property=${form.property}&destination=${form.destination}&landscape=${form.landscape}&typeOfHoliday=${form.typeOfHoliday}`
      )
      .then(({data}) => {
        setCalendarPrice({...data});
      });
  }, [appContext.searchForms[appContext.orderIndex]]);*/

  const getOpenings = () => {
    const today = dayjs();
    const propertiesFiltered = getPropertiesBySearchForm(
      appContext.properties,
      appContext.searchForms[appContext.orderIndex]
    );
    return propertiesFiltered
      .reduce(
        (accumulator: IOpenings[], currentValue) => accumulator.concat(...currentValue.openings),
        []
      )
      .filter((open: any) => dayjs(open.to).isAfter(today));
  };


  const openings: any[] = useMemo(() => getOpenings(), [appContext.searchForms]);

  const [arrivalDateSelection, setArrivalDateSelection] = useState<boolean>(true);

  const isPropertyClosed = (e: any) => {
    // Controllo che la struttura selezionata sia PT
    return appContext.searchForms[appContext.orderIndex].property === 'PT' &&
      appContext.propertySelected === 'PT'
      ? // Disabilito le date in cui la struttura e chiusa oppure il sabato se sto selezionando la data di checkin solo all'interno di un determinato range di date in cui la struttura è aperta
        !openings.find((opening) => e.isBetween(opening.from, opening.to, 'days', '[]')) ||
          (e.day() === 6 &&
            arrivalDateSelection &&
            e.isBetween('2026-05-23T00:00:00.000000Z', '2026-09-05T00:00:00.000000Z', 'days', '[]') ||
            e.isBetween('2027-05-15T00:00:00.000000Z', '2027-09-07T00:00:00.000000Z', 'days', '[]')
          )
      : // Per tutte le altre strutture disabilito le date di chiusura in base al range impostato su Statamic
        !openings.find((opening) => e.isBetween(opening.from, opening.to, 'days', '[]'));
  };

  const disableSaturdayForPT = (date: Dayjs) => {
    const last = appContext.searchForms[appContext.searchForms.length - 1];
    const day = date.day();
    if (last.property === 'PT') {
      return day === 6;
    } else {
      return false;
    }
  };

  const [dateType, setDateType] = useState('1');

  const handleChangeDateType = (event: React.SyntheticEvent, newValue: string) => {
    setDateType(newValue);
  };

  const downMd = useResponsive('down', 'md');

/*  const setDates = (value: DateRange<Dayjs>) => {
    console.log('Picker raw values:', value); // you'll see the T...
    console.log('Formatted:', value[0]?.format('YYYY-MM-DD'), value[1]?.format('YYYY-MM-DD')); // clean
    appContext.setUpdateSearch(true);
    appContext.searchForms[appContext.orderIndex].GuestArrival =
      value[0]?.format('YYYY-MM-DD') || '';
    appContext.searchForms[appContext.orderIndex].GuestDeparture =
      value[1]?.format('YYYY-MM-DD') || '';
    appContext.setSearchForms([...appContext.searchForms]);
  };*/

  const setDates = (value: DateRange<Dayjs>) => {
    const guestArrival = value[0]?.format('YYYY-MM-DD') ?? '';
    const guestDeparture = value[1]?.format('YYYY-MM-DD') ?? '';
    appContext.setUpdateSearch(true);
    const allAccommodationsInSearchForm = appContext.searchForms.map(form => ({
      ...form,
      GuestArrival: guestArrival,
      GuestDeparture: guestDeparture,
    }));

    appContext.setSearchForms(allAccommodationsInSearchForm);
  };

  function CustomToolbar() {
    const count =
      appContext.searchForms[appContext.orderIndex].GuestArrival && appContext.searchForms[appContext.orderIndex].GuestDeparture
        ? dayjs(appContext.searchForms[appContext.orderIndex].GuestDeparture).diff(dayjs(appContext.searchForms[appContext.orderIndex].GuestArrival), 'day') + 1
        : 0;

    return (
      <Box>
        <Typography variant="body1">
          {appContext.searchForms[appContext.orderIndex].GuestArrival ? (
              `${dayjs(appContext.searchForms[appContext.orderIndex].GuestArrival).format('MMM DD')}`
            ) : (
              `${t('start_date_picker_placeholder')}`
          )} -
          {appContext.searchForms[appContext.orderIndex].GuestDeparture ? (
            `${dayjs(appContext.searchForms[appContext.orderIndex].GuestDeparture).format('MMM DD')}`
          ) : (
            `${t('end_date_picker_placeholder')}`
          )} ({count > 0 ? t('nights_selected', { count: count - 1 }) : t('seleziona_range_date')})
        </Typography>
      </Box>
    );
  }

/*
  const firstAvailable = React.useMemo(() => {
    return dayjs(
      appContext.openings.find((opening: any) => dayjs(opening.from).isAfter(dayjs()))?.from
    );
  }, [openings]);
*/

  const firstAvailable = React.useMemo(() => {
    const today = dayjs().startOf('day');

    const first = openings
      .map((o: any) => dayjs(o.from).startOf('day'))
      .find((d) => d.isAfter(today.subtract(1, 'day'), 'day')); // >= today without plugin

    return first ?? today;
  }, [openings]);

  const currentMonthStart = dayjs().startOf('month');
  const currentMonthEnd = dayjs().endOf('month');

  const hasAvailableInCurrentMonth = openings.some(opening =>
      dayjs(opening.from).isBefore(currentMonthEnd) && dayjs(opening.to).isAfter(currentMonthStart)
  );

  const referenceDate = hasAvailableInCurrentMonth
      ? currentMonthStart
      : firstAvailable;

  // const arrival = dayjs(appContext.searchForms[appContext.orderIndex].GuestArrival, 'YYYY-MM-DD');
  // const departure = dayjs(appContext.searchForms[appContext.orderIndex].GuestDeparture, 'YYYY-MM-DD');

  const MyActionBar = () => {
    const { t } = useTranslation();
    return (
      <DialogActions sx={{ display: 'block', textAlign: 'end' }}>
        {website.code === 'VP' ? (
          <Button
            color={'secondary'}
            variant={'containedSecondaryVP'}
            onClick={() => {
              handleCloseModalDatePicker();
            }}>
            {t('Select')}
          </Button>
        ) : (
          <>
{/*
            <Typography variant={'body2'} component={'p'} textAlign={'left'}>{t('disclaimer_price_calendar')}</Typography>
*/}
            <Button
              onClick={() => {
                handleCloseModalDatePicker();
              }}>
              {t('Select')}
            </Button>
          </>
        )}
      </DialogActions>
    );
  };

  return (
    <Box sx={{height: '100%', overflow: 'scroll!important'}}>
      <Grid
        container
        alignItems={'center'}
        justifyContent={'space-evenly'}
        direction={'row'}
        pt={3}
        pb={2}
        pr={2}
        pl={2}
        sx={{borderBottom: '1px solid #F4F3EF', position: 'relative'}}>
        {(props.params.container === 'DrawerSearchWidget' || downMd) && (
          <Box sx={{position: 'absolute', left: 0, cursor: 'pointer'}} p={3} pl={4}>
            <ArrowBackIcon onClick={() => handleCloseModalDatePicker()}/>
          </Box>
        )}
        <Grid size={{xs: 12}} textAlign={'center'}>
          <Typography variant={'h4'} component={'h4'}>
            {t('arrival_and_departure')}
          </Typography>
        </Grid>
      </Grid>

      {/*<Box pr={4} pl={4} pt={3}>
          <Typography component={"p"} variant={"body1"}>La struttura nel periodo dal 01/06 al 01/09 ha un minimum stay di 7 notti</Typography>
      </Box>*/}

      <Box pr={4} pl={4} pt={2}>
        <Typography variant={'h5'} component={'h4'} pb={0}>
          {t('When?')}
        </Typography>

        <Box className={classes.tabDateType}>
          <TabContext value={dateType}>
            <TabList onChange={handleChangeDateType} sx={{display: 'none'}}>
              <Tab label="Scegli le date" value="1"/>
              <Tab label="Date flessibili" value="2"/>
            </TabList>

            <TabPanel value="1" sx={{padding: 0}}>
              <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={appContext.language}>
                <StaticDateRangePicker
                  className={classes.calendar}
                  displayStaticWrapperAs="mobile"
                  disableAutoMonthSwitching={true}
                  referenceDate={referenceDate}
                  reduceAnimations={true}
                  shouldDisableDate={(e) => isPropertyClosed(e)}
                  disablePast={true}
                  calendars={2}
                  value={[
                    appContext.searchForms[appContext.orderIndex].GuestArrival
                      ? dayjs(
                        appContext.searchForms[appContext.orderIndex].GuestArrival,
                        'YYYY-MM-DD'
                      )
                      : null,
                    appContext.searchForms[appContext.orderIndex].GuestDeparture
                      ? dayjs(
                        appContext.searchForms[appContext.orderIndex].GuestDeparture,
                        'YYYY-MM-DD'
                      )
                      : null
                  ]}
                  onRangePositionChange={(e) =>
                    e === 'start' ? setArrivalDateSelection(true) : setArrivalDateSelection(false)
                  }
                  onChange={(e) => setDates(e)}
                  onAccept={() => {
                    handleCloseModalDatePicker();
                  }}
                  slots={{
                    actionBar: MyActionBar,
                    /*day: (p) => PriceRangeDay(p, calendarPrice),*/
                    toolbar: CustomToolbar, // 👈 Add this line
                  }}
                  localeText={{
                    start: t('start_date_picker_placeholder'),
                    end: t('end_date_picker_placeholder'),
                    toolbarTitle:
                      appContext.searchForms[appContext.orderIndex].GuestArrival && appContext.searchForms[appContext.orderIndex].GuestDeparture
                        ? t('selected_days', { count: dayjs(appContext.searchForms[appContext.orderIndex].GuestDeparture).diff(dayjs(appContext.searchForms[appContext.orderIndex].GuestArrival), 'day') + 1 })
                        : t('select_range')
                  }}
                  showDaysOutsideCurrentMonth={true}
                  slotProps={{
                    actionBar: {
                      // The actions will be the same between desktop and mobile
                      actions: ['accept']
                    },
                    toolbar: {
                      toolbarFormat: 'MMM DD'
                    },
                  }}
                />
              </LocalizationProvider>
            </TabPanel>

            {/*<TabPanel value="2" sx={{padding: 0, paddingTop: 3}}>
              <Box pt={2} pb={2}>
                <hr/>

                <Typography variant={'body1'} component={'p'} pt={3} pb={2}>
                  Quanto vorresti che durasse il tuo soggiorno?
                </Typography>

                <Grid
                  container
                  direction={'row'}
                  justifyContent={'space-between'}
                  alignItems={'center'}
                  pb={3}>
                  <Grid item className={classes.boxRange}>
                    <Typography component={'p'} variant={'body1'}>
                      2 o 3 giorni
                    </Typography>
                  </Grid>
                  <Grid item className={classes.boxRange}>
                    <Typography component={'p'} variant={'body1'}>
                      1 settimana
                    </Typography>
                  </Grid>
                  <Grid item className={classes.boxRange}>
                    <Typography component={'p'} variant={'body1'}>
                      2 settimane
                    </Typography>
                  </Grid>
                </Grid>

                <hr/>

                <Typography variant={'body1'} component={'p'} pt={3} pb={2}>
                  In quale mese vuoi viaggiare?
                </Typography>

                <Slider {...sliderSetting} className={classes.sliderMonth}>
                  <Box className={classes.boxMonth}>
                    <CalendarMonthIcon/>
                    <Typography component={'p'} variant={'body1'}>
                      Gennaio
                    </Typography>
                    <Typography component={'p'} variant={'body1'}>
                      2023
                    </Typography>
                  </Box>

                  <Box className={classes.boxMonth}>
                    <CalendarMonthIcon/>
                    <Typography component={'p'} variant={'body1'}>
                      Febbraio
                    </Typography>
                    <Typography component={'p'} variant={'body1'}>
                      2023
                    </Typography>
                  </Box>

                  <Box className={classes.boxMonth}>
                    <CalendarMonthIcon/>
                    <Typography component={'p'} variant={'body1'}>
                      Marzo
                    </Typography>
                    <Typography component={'p'} variant={'body1'}>
                      2023
                    </Typography>
                  </Box>

                  <Box className={classes.boxMonth}>
                    <CalendarMonthIcon/>
                    <Typography component={'p'} variant={'body1'}>
                      Aprile
                    </Typography>
                    <Typography component={'p'} variant={'body1'}>
                      2023
                    </Typography>
                  </Box>

                  <Box className={classes.boxMonth}>
                    <CalendarMonthIcon/>
                    <Typography component={'p'} variant={'body1'}>
                      Maggio
                    </Typography>
                    <Typography component={'p'} variant={'body1'}>
                      2023
                    </Typography>
                  </Box>
                </Slider>
              </Box>
            </TabPanel>*/}
          </TabContext>
        </Box>
      </Box>

      {downMd && (
        <Paper elevation={2} className={classes.confirmBtn}>
          <Button
            color="primary"
            variant="outlined"
            onClick={() => props.params.handleCloseModalDatePicker()}>
            {t('Conferma')}
          </Button>
        </Paper>
      )}
    </Box>
  );
};

const useStyles = makeStyles()((theme) => {
  return {
    calendar: {
      '.MuiPickersArrowSwitcher-root': {
        padding: '12px 0px 4px 0px'
      },
      '.MuiDialogActions-root p': {
        marginTop: '10px',
        marginBottom: '20px',
        color: '#AFAFAF'
      },
      '.MuiPickersSlideTransition-root': {
        overflow: 'visible!important',
        minHeight: 'auto!important'
      },
      '.MuiPickersToolbarText-root': {
        fontSize: 16
      },
      '.MuiDateRangePickerToolbar-root': {
        padding: 0,
        '.MuiTypography-overline, .MuiPickersToolbar-penIconButton': {
          display: 'none'
        },
        '.MuiTypography-root': {
          borderBottom: '4px solid transparent',
          color: '#000',
          fontFamily: theme.typography.h6.fontFamily + '!important',
          '&.Mui-selected': {
            borderBottom: '4px solid ' + theme.palette.primary.main,
            fontFamily: theme.typography.h5.fontFamily + '!important'
          }
        }
      },
      '.MuiPickersCalendarHeader-root': {
        paddingBottom: 16,
        paddingRight: 0,
        paddingLeft: 0
      },
      '.MuiPickersCalendarHeader-label': {
        cursor: 'default!important'
      },
      '.MuiDayCalendar-header': {
        justifyContent: 'space-between',
        borderBottom: '1px solid ' + theme.palette.primary.main,
        '.MuiDayCalendar-weekDayLabel': {
          /*width: 55,*/
          width: 40,
          textAlign: 'center',
          justifyContent: 'center',
          margin: 0,
          fontSize: 12,
          color: '#000'
        }
      },
      '.MuiDayCalendar-weekContainer': {
        display: 'flex',
        justifyContent: 'space-between',
        /*justifyContent: 'space-around',*/
        '.MuiBox-root': {
          width: 'auto!important'
        },
        '.MuiDateRangePickerDay-root': {
          width: '100%!important',
          textAlign: 'center',
          margin: 0,
          '.MuiPickersDay-root': {
            fontFamily: theme.typography.h1.fontFamily,
            '&.Mui-disabled': {
              fontFamily: theme.typography.body1.fontFamily
            }
          }
        }
      },
      '.MuiDialogActions-root': {
        button: {
          color: '#FFF',
          backgroundColor: '#000',
          textTransform: 'uppercase',
          borderRadius: 0,
          padding: '10px 55px',
          marginBottom: 20,
          [theme.breakpoints.down('md')]: {
            display: 'none'
          },
          '&:hover': {
            color: '#FFF' + '!important'
          }
        }
      },
      '.MuiDateRangeCalendar-root': {
        [theme.breakpoints.down('sm')]: {
          display: 'block',
          paddingBottom: '90px'
        },
        '.MuiDateRangeCalendar-monthContainer': {
          '&:first-child': {
            paddingRight: 10,
            [theme.breakpoints.down('sm')]: {
              paddingRight: 0,
              borderRight: 0
            }
          },
          '&:last-child': {
            paddingLeft: 10,
            [theme.breakpoints.down('sm')]: {
              paddingLeft: 0
            }
          }
        }
      }
    },
    confirmBtn: {
      position: 'absolute',
      bottom: 0,
      right: 0,
      left: 0,
      padding: '20px 32px',
      boxShadow: '0 -3px 10px #00000029',
      fontFamily: theme.typography.h6.fontFamily,
      '.MuiButton-root': {
        width: '100%',
        backgroundColor: '#000',
        color: '#FFF',
        borderRadius: 0,
        fontSize: 20,
        border: 'none',
        '&:hover': {
          backgroundColor: '#000',
          color: '#FFF',
          borderColor: '#000'
        }
      }
    },
    tabDateType: {
      '.MuiTabs-root': {
        border: '1px solid #efefef',
        minHeight: '40px!important',
        '.Mui-selected': {
          color: '#000',
          zIndex: 2
        },
        '.MuiTab-root': {
          width: '50%',
          minHeight: 40,
          padding: '10px 16px',
          textTransform: 'initial',
          color: '#000',
          fontFamily: theme.typography.body1.fontFamily,
          '&.Mui-selected': {
            fontFamily: theme.typography.h1.fontFamily
          }
        },
        '.MuiTabs-scroller': {
          margin: '4px!important'
        }
      },
      '.MuiTabs-indicator': {
        height: '100%!important',
        borderRadius: 4
      },
      '.MuiTabs-flexContainer': {
        justifyContent: 'space-between'
      },
      '.MuiPickersLayout-root': {
        display: 'initial!important'
      },
      '.MuiDateRangeCalendar-monthContainer': {
        width: '100%!important'
      },
      hr: {
        borderColor: '#97ddcd',
        height: 0,
        margin: 0,
        borderStyle: 'solid'
      }
    },
    boxRange: {
      border: '1px solid #97ddcd',
      backgroundColor: '#FFF',
      color: '#000',
      textAlign: 'center',
      padding: '6px 12px'
    },
    sliderMonth: {
      '.slick-slide': {
        margin: 4
      }
    },
    boxMonth: {
      border: '1px solid #97ddcd',
      backgroundColor: '#FFF',
      color: '#000',
      textAlign: 'center',
      padding: '8px 0',
      minWidth: 'inherit!important'
    }
  };
});


const getRandomPrice = () => {
  const min = 9.0;
  const max = 300.99;
  const value = Math.random() * (max - min) + min;
  return value.toFixed(0); // строка с двумя знаками после запятой
};

/*const PriceRangeDay: React.FC<DateRangePickerDayProps> = (props, calendarPrices) => {
  const { day, outsideCurrentMonth } = props;
  const key = day.format('YYYY-MM-DD');
  const price = calendarPrices[key] ? `€${ parseInt(calendarPrices[key]) }` : null;

  console.log(props.outsideCurrentMonth)

  return (
    <Box sx={{ position: 'relative', width: 55 }}>
      <DateRangePickerDay {...props} />
      {price != null && !props.outsideCurrentMonth && (
        <Typography
          variant="caption"
          sx={{
            position: 'absolute',
            bottom: 2,
            left: '50%',
            transform: 'translateX(-50%)',
            fontSize: 10,
            pointerEvents: 'none',
            opacity: outsideCurrentMonth ? 0.4 : 1
          }}>
          {price}
        </Typography>
      )}
    </Box>
  );
};*/
